import { useCallback } from 'react';
import { Theme } from '../../../types';

const getPalettesStorageKey = (klydoId: string) => `klydo-palettes-${klydoId}`;

const usePalettesLocalStorage = (klydoId?: string) => {
  const loadPalettes = useCallback((): Theme[] | null => {
    if (!klydoId) return null;

    try {
      const stored = localStorage.getItem(getPalettesStorageKey(klydoId));
      return stored ? JSON.parse(stored) : null;
    } catch (error) {
      console.error('Error loading palettes from localStorage:', error);
      return null;
    }
  }, [klydoId]);

  const savePalettes = useCallback(
    (palettes: Theme[]) => {
      if (!klydoId) return;

      try {
        localStorage.setItem(
          getPalettesStorageKey(klydoId),
          JSON.stringify(palettes),
        );
      } catch (error) {
        console.error('Error saving palettes to localStorage:', error);
      }
    },
    [klydoId],
  );

  const clearPalettes = useCallback(() => {
    if (!klydoId) return;

    try {
      localStorage.removeItem(getPalettesStorageKey(klydoId));
    } catch (error) {
      console.error('Error clearing palettes from localStorage:', error);
    }
  }, [klydoId]);

  return {
    loadPalettes,
    savePalettes,
    clearPalettes,
  };
};

export default usePalettesLocalStorage;
